var _g, _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangeNumberPhoneFailedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 62,
    viewBox: "0 0 71 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_436_831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1211 12.3047C10.7291 12.3047 7.96875 9.54437 7.96875 6.15234C7.96875 2.76031 10.7291 0 14.1211 0C17.5131 0 20.2734 2.76031 20.2734 6.15234C20.2734 9.54437 17.5131 12.3047 14.1211 12.3047Z",
    fill: "#5AB43A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9414 12.3047C26.5494 12.3047 23.7891 9.54437 23.7891 6.15234C23.7891 2.76031 26.5494 0 29.9414 0C33.3334 0 36.0938 2.76031 36.0938 6.15234C36.0938 9.54437 33.3334 12.3047 29.9414 12.3047Z",
    fill: "#5AB43A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9027 12.3047C42.5107 12.3047 39.7504 9.54437 39.7504 6.15234C39.7504 2.76031 42.5107 0 45.9027 0C49.2947 0 52.0551 2.76031 52.0551 6.15234C52.0551 9.54437 49.2947 12.3047 45.9027 12.3047Z",
    fill: "#5AB43A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1211 28.2422C10.7291 28.2422 7.96875 25.4819 7.96875 22.0898C7.96875 18.6978 10.7291 15.9375 14.1211 15.9375C17.5131 15.9375 20.2734 18.6978 20.2734 22.0898C20.2734 25.4819 17.5131 28.2422 14.1211 28.2422Z",
    fill: "#5AB43A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9414 28.2422C26.5494 28.2422 23.7891 25.4819 23.7891 22.0898C23.7891 18.6978 26.5494 15.9375 29.9414 15.9375C33.3334 15.9375 36.0938 18.6978 36.0938 22.0898C36.0938 25.4819 33.3334 28.2422 29.9414 28.2422Z",
    fill: "#5AB43A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9027 28.2422C42.5107 28.2422 39.7504 25.4819 39.7504 22.0898C39.7504 18.6978 42.5107 15.9375 45.9027 15.9375C49.2947 15.9375 52.0551 18.6978 52.0551 22.0898C52.0551 25.4819 49.2947 28.2422 45.9027 28.2422Z",
    fill: "#5AB43A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1211 44.0625C10.7291 44.0625 7.96875 41.3022 7.96875 37.9102C7.96875 34.5181 10.7291 31.7578 14.1211 31.7578C17.5131 31.7578 20.2734 34.5181 20.2734 37.9102C20.2734 41.3022 17.5131 44.0625 14.1211 44.0625Z",
    fill: "#5AB43A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9414 44.0625C26.5494 44.0625 23.7891 41.3022 23.7891 37.9102C23.7891 34.5181 26.5494 31.7578 29.9414 31.7578C33.3334 31.7578 36.0938 34.5181 36.0938 37.9102C36.0938 41.3022 33.3334 44.0625 29.9414 44.0625Z",
    fill: "#5AB43A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9414 60C26.5494 60 23.7891 57.2397 23.7891 53.8477C23.7891 50.4556 26.5494 47.6953 29.9414 47.6953C33.3334 47.6953 36.0938 50.4556 36.0938 53.8477C36.0938 57.2397 33.3334 60 29.9414 60Z",
    fill: "#5AB43A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9027 44.0625C42.5107 44.0625 39.7504 41.3022 39.7504 37.9102C39.7504 34.5181 42.5107 31.7578 45.9027 31.7578C49.2947 31.7578 52.0551 34.5181 52.0551 37.9102C52.0551 41.3022 49.2947 44.0625 45.9027 44.0625Z",
    fill: "#5AB43A"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 46,
    r: 16,
    fill: "#FF5200"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5599 39.6799C50.0403 39.1606 49.1997 39.1604 48.6801 39.6799C48.1604 40.1995 48.1604 41.0405 48.6801 41.5601L53.3437 46.2238L48.6801 50.8875L48.68 50.8876C48.1604 51.4071 48.1606 52.2481 48.6801 52.7676C48.9392 53.0268 49.2804 53.157 49.62 53.157C49.9598 53.157 50.3009 53.0266 50.56 52.7675L55.2236 48.1038L59.8874 52.7675C60.1465 53.0266 60.4876 53.157 60.8274 53.157C61.1672 53.157 61.5083 53.0266 61.7674 52.7675C62.2871 52.248 62.287 51.407 61.7673 50.8875L57.1038 46.2238L61.7673 41.5601C62.2871 41.0405 62.2871 40.1996 61.7674 39.68C61.2479 39.1605 60.407 39.1605 59.8874 39.68L55.2236 44.3438L50.5599 39.6799Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_436_831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeNumberPhoneFailedIcon);
export default __webpack_public_path__ + "static/media/changeNumberPhoneFailedIcon.f77ed54f4e2dda99ade30f131ae7bf54.svg";
export { ForwardRef as ReactComponent };